import styled from "styled-components";

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;  
  text-align: center;
`;

export default ContentContainer;
